import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';

import images from '_images';

import { setHelpDamagedCartData as setHelpDamagedCartDataAction } from '../../redux/actions';
import getNextActiveScreen from '../../helpers';

const Container = styled.div`
  width: 80%;
  margin: auto;
  padding: 20px;
`;

const ButtonsContainer = styled.ul`
  margin-bottom: 30px;
  padding: 0;

  & li {
    list-style: none;
  }
`;

const Button = styled.button`
  width: 100%;
  height: auto;
  border: none;
  display: flex;
  padding: 15px;
  cursor: pointer;
  min-height: 50px;
  margin-bottom: 5px;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom: 1px solid #dbdbdb;
  padding-left: 0 !important;
  align-items: center;
`;

const TitleContainer = styled.div`
  flex: 1;
`;

const Title = styled.p`
  margin: 0;
  padding: 0;
  font-size: 16px;
  text-align: left;
  font-family: Roboto, sans-serif;
`;

const ArrowContainer = styled.div`
  flex: 1;
  max-width: 16px;
`;

const Arrow = styled.img`
  width: 100%;
  height: 100%;
`;

const IsMissingOrDamagedPage = ({
  data,
  url,
  damaged_cart_data,
  damaged_cart_form_data,
  setHelpDamagedCartData,
}) => {
  const [bodyPartPageIsOpen, setBodyPartPageIsOpen] = useState(false);
  const { push } = useHistory();
  const { oidx } = useParams();
  const hasBodyPartDamagedPage = data?.damaged_parts_page.is_active === 'true';
  const isImageMandatory = data?.image_is_mandatory_for_damaged_cart === 'true';

  const buttonOnClick = (type) => () => {
    setBodyPartPageIsOpen(!bodyPartPageIsOpen);

    if (type === 'missing') {
      setHelpDamagedCartData({
        ...damaged_cart_form_data,
        missingOrDamaged: 'Missing',
        damagedParts: [],
        isImageMandatory: false,
      });
      const nextPage = getNextActiveScreen(
        damaged_cart_data.find(({ oidx: index }) => index === Number(oidx)),
        data.page,
        url
      );
      push(nextPage, {
        damaged_cart_data: damaged_cart_data.find(
          ({ oidx: index }) => index === Number(oidx)
        ),
      });
      return;
    }

    if (type === 'damaged') {
      setHelpDamagedCartData({
        ...damaged_cart_form_data,
        missingOrDamaged: 'Damaged',
        isImageMandatory,
      });
      if (hasBodyPartDamagedPage) {
        push(`${url}/damaged-parts-page`);
      } else {
        const nextPage = getNextActiveScreen(
          damaged_cart_data.find(({ oidx: index }) => index === Number(oidx)),
          data.page,
          url
        );
        push(nextPage, {
          damaged_cart_data: damaged_cart_data.find(
            ({ oidx: index }) => index === Number(oidx)
          ),
        });
      }
    }
  };

  return (
    <Container>
      <h3>I want to report:</h3>
      <ButtonsContainer>
        <li>
          <Button onClick={buttonOnClick('missing')}>
            <TitleContainer>
              <Title>{data?.missing_cart_button_label}</Title>
            </TitleContainer>
            <ArrowContainer>
              <Arrow src={images.calendar.rightArrow} alt="Missing cart button" />
            </ArrowContainer>
          </Button>
        </li>
        <li>
          <Button
            onClick={buttonOnClick('damaged')}
            style={{
              borderBottom:
                hasBodyPartDamagedPage && bodyPartPageIsOpen
                  ? '1px solid transparent'
                  : '1px solid #dbdbdb',
            }}
          >
            <TitleContainer>
              <Title>{data?.damaged_cart_button_label}</Title>
            </TitleContainer>
            <ArrowContainer>
              <Arrow src={images.calendar.rightArrow} alt="Damaged cart button" />
            </ArrowContainer>
          </Button>
        </li>
      </ButtonsContainer>
    </Container>
  );
};

export default connect(
  (store) => ({
    damaged_cart_data: store?.help?.helpItems.filter(
      ({ type }) => type === 'DAMAGED_CART'
    ),
    damaged_cart_form_data: store?.help?.damagedCartFormData,
  }),
  (dispatch) => ({
    setHelpDamagedCartData: (data) => dispatch(setHelpDamagedCartDataAction(data)),
  })
)(IsMissingOrDamagedPage);
